<div class="panel">
  <div class="panel__group">
    <div class="panel__search">
      <div class="panel__flex">
        <div class="panel__controls">
          <div class="hidden__mobile">
            <ng-container>
              <app-button
                (btnClick)="goBack()"
                type="button"
                color="return"
                icon="agres-return"
                title="{{ 'global.back' | translate }}"></app-button>
            </ng-container>
          </div>
          <div
            class="combobox-container"
            *ngIf="this.isIsobus === true && this.isTaskActive === true && this.devices.length > 0">
            <select id="device-select" [(ngModel)]="selectedDevice" (change)="onDeviceSelect()">
              <option *ngFor="let device of devices" [value]="device.deviceDesignator">
                {{ device.deviceDesignator }}
              </option>
            </select>
          </div>
          <div *ngIf="this.isIsobus === true" class="device-connected">
            <small class="notify notify__danger" *ngIf="!isCurrentDeviceConnected"
              >*{{ 'monitoring.error-device-not-connected' | translate }}</small
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<section>
  <app-trail
    [receivedDeviceInfo]="deviceInfo"
    [initialArray]="circles"
    [currentTab]="currentTab"
    [navigationTab]="navigationTabInfo"
    [operationTab]="operationTabInfo"
    [totalTab]="totalTabInfo"
    [staticMessageOperationTabInfo]="staticMessageOperationTabInfo"
    [machineTab]="machineTabInfo"
    (processingComplete)="onProcessingComplete()">
  </app-trail>
</section>
<app-menu-pwa>
  <div class="pwa__list--info">
    <button type="button" (click)="dashboard()">
      <i class="agres-app"></i>
      <p>{{ 'sidebar.title-dashboard' | translate }}</p>
    </button>
  </div>
</app-menu-pwa>
